export default __webpack_public_path__ + "static/media/location.eb82e960.svg";